import * as React from 'react'

import { Features } from 'generated/featureDefinitions'
import { CompensationsSettingsPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

import { usePayrollPaywallingGuard } from 'modules/payroll_bundle/hooks/usePayrollPaywallGuard'

interface PayrollPaywallGuardProps {
  children: React.ReactNode
}

const PayrollPaywallGuard = ({ children }: PayrollPaywallGuardProps) => {
  const { loadingFeatures, isPayrollAvailable } = usePayrollPaywallingGuard()
  const session = useCurrentSession()
  const { data: featuresData } = useQuery(CompensationsSettingsPageDocument, {
    variables: {
      companyId: session.company.id,
      featureIds: [],
      featureAvailabilitiesIds: [Features.compensations_management],
    },
  })

  const featureAvailabilities = useUnsafeMemo(
    () => featuresData?.companies?.featureAvailabilitiesConnection.nodes || [],
    [featuresData]
  )

  const compensationsEnabled = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.compensations_management
  )

  if (loadingFeatures) return <div data-testid="loading-payroll-feature" />

  if (!isPayrollAvailable && !compensationsEnabled) return <NotFound />

  return <>{children}</>
}

export default PayrollPaywallGuard
